import { PeopleOutline } from "@mui/icons-material";
import { IconButton, Tooltip, Zoom } from "@mui/material";
import { useNavigate } from "react-router-dom";

import { CompanyAdminDetailsButton } from "components/CompanyAdminDetailsButton";
import { userHasAdminRoleInCompany } from "utils";

import { useAuthContext, useRoleContext } from "../../../hooks";
import { NavBarButtonWrapper } from "../NavBarButtonWrapper";
import { isCompanyRouteActive, NAV_ROUTES } from "../routes";

interface AdminNavBarItemsProps {
  pathName: string;
}

export function AdminNavBarItems(props: AdminNavBarItemsProps) {
  const { pathName } = props;
  const navigate = useNavigate();
  const { user } = useAuthContext();
  const { company, hasBranchAdminRole, hasCompanyAdminRole } = useRoleContext();

  return (
    <>
      {/* A user that has both roles should only see the company admin button */}
      {company != null && hasBranchAdminRole() && !hasCompanyAdminRole() && (
        <NavBarButtonWrapper
          isActive={isCompanyRouteActive(pathName, "branches")}
        >
          <Tooltip
            title="Company Branches"
            placement="right"
            TransitionComponent={Zoom}
          >
            <IconButton
              color="inherit"
              onClick={() => navigate(NAV_ROUTES.companyBranches(company.id))}
            >
              <PeopleOutline fontSize="large" />
            </IconButton>
          </Tooltip>
        </NavBarButtonWrapper>
      )}
      {user != null && userHasAdminRoleInCompany(user) && (
        <NavBarButtonWrapper isActive={isCompanyRouteActive(pathName, "admin")}>
          <CompanyAdminDetailsButton />
        </NavBarButtonWrapper>
      )}
    </>
  );
}
